import React, { useState, useEffect } from "react";
import { blogPosts as blogPostsService } from "../../services/api";

interface DashboardStats {
  totalPosts: number;
  activePosts: number;
}

export default function Dashboard() {
  const [stats, setStats] = useState<DashboardStats>({
    totalPosts: 0,
    activePosts: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadStats = async () => {
      try {
        const response = (await blogPostsService.list({ limit: 1000 })) as any;
        if (response && response.posts) {
          const posts = response.posts;
          const activePosts = posts.filter(
            (p: any) => p.is_published || p.published_at
          ).length;

          setStats({
            totalPosts: posts.length,
            activePosts: activePosts,
          });
        }
      } catch (error) {
        console.error("Error loading dashboard stats:", error);
      } finally {
        setLoading(false);
      }
    };

    loadStats();
  }, []);

  return (
    <div className="page-layout">
      <div className="page-header">
        <h2 className="title">Dashboard</h2>
        <div className="right"></div>
      </div>

      <div className="dashboard-stats mt-4">
        <div className="stat-card">
          <div className="stat-icon">
            <i className="fa-solid fa-file-lines"></i>
          </div>
          <div className="stat-content">
            <h3>{loading ? "..." : stats.totalPosts}</h3>
            <p>Total Posts</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon published">
            <i className="fa-solid fa-check-circle"></i>
          </div>
          <div className="stat-content">
            <h3>{loading ? "..." : stats.activePosts}</h3>
            <p>Active Posts</p>
          </div>
        </div>
      </div>

      <div className="section-card"></div>
    </div>
  );
}
